import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { TOKEN } from "../../common/constants";
import { apiLogout } from "../../api/auth";
import firebaseMessagingService from "../../services/firebaseMessaging";
import "./sidebar.css";

// Custom icon component
const CustomIcon = ({ src, isActive }) => {
  return (
    <img
      src={src}
      alt=""
      className="w-5 h-5"
      style={{
        filter: isActive
          ? "invert(48%) sepia(79%) saturate(2476%) hue-rotate(236deg) brightness(92%) contrast(98%)"
          : "invert(60%) sepia(8%) saturate(434%) hue-rotate(182deg) brightness(92%) contrast(87%)",
      }}
    />
  );
};

const menuItems = [
  { key: "/", icon: "/icon/dashboard_icon.svg", label: "Dashboard" },
  { key: "/patients", icon: "/icon/patients_icon.svg", label: "Patients" },
  {
    key: "/follow-ups",
    icon: "/icon/followups_icon.svg",
    label: "Follow-ups",
  },
    {
    key: "/plans",
    icon: "/icon/appointments_icon.svg",
    label: "Plans",
  },
  {
    key: "/appointments",
    icon: "/icon/appointments_icon.svg",
    label: "Appointments",
  },
  {
    key: "/prescriptions",
    icon: "/icon/prescription_icon.svg",
    label: "Prescriptions",
  },
  { key: "/messages", icon: "/icon/message_icon.svg", label: "Messages" },
  { key: "/profile", icon: "/icon/profile_icon.svg", label: "Profile" },
];

function Sidebar({ collapsed }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const fcmToken = firebaseMessagingService.getStoredFCMToken();
      
      if (fcmToken) {
        await apiLogout(fcmToken);
      }
    } catch (error) {
      console.error('Error during logout API call:', error);
    } finally {
      firebaseMessagingService.clearFCMToken();
      
      localStorage.removeItem(TOKEN);
      localStorage.removeItem("user");
      localStorage.removeItem("deviceId"); // Also clear device ID
      
      // Navigate to login
      navigate("/login");
    }
  };

  const getSelectedKey = () => {
    const pathname = location.pathname;
    if (pathname === "/") return ["/"];
    const firstSegment = "/" + pathname.split("/").filter(Boolean)[0];
    const matchedItem = menuItems.find((item) => item.key === firstSegment);
    return matchedItem ? [firstSegment] : [pathname];
  };

  const selectedKeys = getSelectedKey();

  const renderMenuItems = menuItems.map((item) => ({
    key: item.key,
    icon: (
      <CustomIcon src={item.icon} isActive={selectedKeys.includes(item.key)} />
    ),
    label: item.label,
  }));

  return (
    <div className="sidebar-container">
      {/* Logo */}
      <div className="sidebar-logo">
        <img src="/images/logo.png" alt="MedRev Logo" className="h-12 w-auto" />
      </div>

      {/* Menu */}
      <div className="sidebar-menu-wrapper">
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          items={renderMenuItems}
          onClick={({ key }) => navigate(key)}
        />
      </div>

      {/* Logout */}
      <div className="sidebar-footer">
        <div className="sidebar-logout" onClick={handleLogout}>
          <img src="/icon/logout_icon.svg" alt="logout" className="h-5 w-5" />
          <span>Logout</span>
        </div>
        <div className="sidebar-copyright">
          MedRev © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
